import {ThemeProvider as BaseThemeProvider, StylesProvider, jssPreset} from '@yandex-taxi/go-web-components'
import {create} from 'jss'
import rtl from 'jss-rtl'
import React, {useMemo} from 'react'
import {config} from 'src/shared/config'
import {useTheme} from 'src/shared/hooks'

import {createRouteMuiTheme} from './mui-theme'

let plugins = jssPreset().plugins

if (config.dir === 'rtl') {
  plugins = plugins.concat(rtl())
}

const jss = create({plugins})

type Props = {
  children: React.ReactNode
}

/** MUI/JSS ThemeProvider для legacy drawer и go-web-components */
export function RouteMuiThemeProvider({children}: Props): React.ReactElement {
  const mode = useTheme()
  const muiTheme = useMemo(() => createRouteMuiTheme(mode, config.dir), [mode])

  return (
    <StylesProvider jss={jss}>
      <BaseThemeProvider theme={muiTheme}>{children}</BaseThemeProvider>
    </StylesProvider>
  )
}
